import React, { Component } from 'react';
import { Router, Route, Switch, withRouter } from 'react-router';
import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import {
  ROLE_CREATE_DRIVER,
  ROLE_EDIT_DRIVER,
  ROLE_SHOW_DRIVER,
} from 'helpers/roles';

import List from './List';
import Form from './Form';

class Drivers extends Component {
  render() {
    const { props } = this;

    const ListSecured = withRole(ROLE_SHOW_DRIVER, List);
    const CreateForm = withRole(ROLE_CREATE_DRIVER, Form);
    const EditForm = withRole(ROLE_EDIT_DRIVER, Form);

    return (
      <DataGridStateContextProvider>
        <Router history={this.props.history}>
          <Switch>
            <Route
              exact={true}
              path={`${this.props.match.url}/`}
              render={parentProps => <ListSecured {...props} {...parentProps} />}
            />
            <Route
              path={`${this.props.match.url}/add`}
              render={() => <CreateForm {...props} />}
            />
            <Route
              path={`${this.props.match.url}/edit/:id`}
              render={parentProps => <EditForm {...props} {...parentProps} />}
            />
          </Switch>
        </Router>
      </DataGridStateContextProvider>
    );
  }
}

export default withRouter(Drivers);
